import { createFileRoute } from '@tanstack/react-router';

import { DeleteAccountConfirmation } from 'src/apps/account/app/components/DeleteAccount';

export const Route = createFileRoute(
  '/_auth/_layout/account/delete/confirmation'
)({
  component: () => <DeleteAccountConfirmation variant="browser" />,
});
